/* eslint-disable no-nested-ternary */
/* eslint-disable prefer-destructuring */
/* eslint-disable react/no-array-index-key */
import { useState, useEffect, useRef } from 'react';

import {
  useFormik,
} from 'formik';
import * as yup from 'yup';
import {
  Grid,
  Typography,
  Button,
  Collapse,
  TextField,
  IconButton,
  FormControl,
  CircularProgress,
  Autocomplete,
  createFilterOptions,
} from '@mui/material';
import { SearchOutlined } from '@mui/icons-material';
import {
  useAddUserProjectMutation,
  useGetCompanyManagerListLazyQuery,
  UserNode,
  useUserListFromProjectQuery,
  useDeleteUserProjectMutation,
  AddUserInput,
} from '../../../../../graphql/generated/graphql';
import { useProjectsState } from '../../../../hooks/projectsInfo';
import { AddContactForm, CompanyManager } from '../../../../config/interfaces';
import JobTitle from '../../../components/job-title';
import ContactsTable from './table';
import { useLoginState } from '../../../../hooks/loginInfo';
import CircularLoading from '../../../components/common/CircularLoading';
import { setAlertDescription } from '../../../../hooks/actions';
import './index.scss'

const ContactsPage = () => {
  const currentProject = useProjectsState().projectId.get() || '';
  const [addUserProject] = useAddUserProjectMutation();
  const [deleteUserProject] = useDeleteUserProjectMutation();

  const [openInfoContact, setOpenInfoContact] = useState(false);
  const [options, setOptions] = useState<CompanyManager[]>([]);
  const [toCleanJobTitle, setToCleanJobTitle] = useState<boolean>(false);

  const [canEditing] = useState(useLoginState().can_edit.get());
  const [add, setAdd] = useState(false);
  const [preValue, setPreValue] = useState('');
  const [loader, setLoader] = useState(false);
  const [addedContact, setAddedContact] = useState(false);
  const nameRef = useRef<any>()
  const clearFieldName = () => {
    if (nameRef && nameRef.current && nameRef.current.querySelector('button')) {
      const buttonClean = nameRef.current.querySelector('button')
      buttonClean.click();
    }
  }
  const [valueInfoUser, setValueInfoUser] = useState<CompanyManager | null | undefined>();
  const [getCompanyManager, { data: listCompanyManagers, loading: loadingSearch }] = useGetCompanyManagerListLazyQuery();

  const [disabledField, setDisabledField] = useState(false)

  const [openModal, setOpenModal] = useState(false);

  const { data: contacts, loading: loadingContacts, refetch } = useUserListFromProjectQuery({
    variables: {
      name_or_email: '',
      project_id: currentProject,
    },
  });

  const contactsProjectHandle = async (value: string) => {
    setPreValue(value);
    const variables = {
      name_or_email: value,
      project_id: currentProject,
    }
    if (refetch) {
      refetch(variables);
    }
  };

  const onChangeSearchUserHandle = async (value: string) => {
    formik.setFieldValue('name', value)
    if (value.length > 2) {
      getCompanyManager({
        variables: {
          name_or_email: value,
        },
      })
    } else {
      getCompanyManager({
        variables: {
          name_or_email: '/',
        },
      })
    }
  };

  const deleteUsers = async (value: AddUserInput | AddUserInput[]) => {
    try {
      await deleteUserProject({
        variables: {
          project_id: currentProject,
          users: value,
        },
      }).then(() => {
        if (refetch) {
          refetch({
            name_or_email: '',
            project_id: currentProject,
          });
        }
        setAlertDescription({
          open: true,
          message: 'The users selected has been deleted from project',
          severity: 'success',
        });
      });
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    if (listCompanyManagers) {
      setOptions(listCompanyManagers.getCompanyManagerList as CompanyManager[]);
    }
  }, [listCompanyManagers]);

  useEffect(() => {
    contactsProjectHandle('');
  }, []);

  const initialValues: AddContactForm = {
    name: '',
    email: '',
    jobTitle: '',
    phone: '',
  };
  const AddContactSchema = yup.object().shape({
    name: yup.string()
      .min(2, 'Too Short!')
      .max(50, 'Too Long!')
      .required('Required'),
    email: yup.string()
      .email('Invalid email')
      .required('Required'),
    jobTitle: yup.string()
      .required('Required'),
    phone: yup.string()
      .min(6, 'Too Short!')
      .max(12, 'Too Long!')
      .required('Required'),
  });
  const formik = useFormik({
    initialValues,
    validationSchema: AddContactSchema,
    onSubmit: async (variables) => {
      setLoader(true);
      try {
        await addUserProject({
          variables: {
            project_id: currentProject,
            users: [{
              email: variables.email,
              name: variables.name,
              job_title_id: variables.jobTitle,
              phone: variables.phone
            }],
          },
        }).then(() => {
          setDisabledField(false);
          setAdd(false);
          setAddedContact(true);
          setValueInfoUser(null);
          contactsProjectHandle('');
          formik.resetForm();
          setToCleanJobTitle(true);
          setAlertDescription({
            open: true,
            message: 'The user has been added to the project',
            severity: 'success',
          });
        });
      } catch (e) {
        console.error(e);
      }
      setLoader(false);
    },
  });

  const handleCloseModal = () => {
    setOpenModal(false)
    if (refetch) {
      refetch({
        name_or_email: '',
        project_id: currentProject,
      });
    }
  };

  const handleOpenModal = () => {
    setOpenModal(true)
  };

  useEffect(() => {
    if (!disabledField) {
      clearFieldName();
    }
  }, [disabledField])

  //set ready to another clear to jobtitle
  useEffect(() => {
    if (toCleanJobTitle) {
      setToCleanJobTitle(false)
    }
  }, [toCleanJobTitle])

  return (
    <>
      <Grid
        className='header'
      >
        <Typography
          component="h1"
          variant="h2"
          sx={{
            mb: 2,
            fontWeight: 500,
          }}
        >
          Project Contacts
        </Typography>
        <Grid
          sx={{
            display: 'flex',
          }}
        >
          {canEditing && (
            <Button
              type="submit"
              variant="contained"
              disabled={add}
              onClick={() => {
                setAdd(true);
                setAddedContact(false);
              }}
              sx={{
                width: '135px',
                mr: 1,
                fontWeight: 500,
              }}
            >
              Add contact
            </Button>
          )}
          <TextField
            required
            id="search"
            label="Search"
            onBlur={(event) => {
              if (event.target.value !== preValue) { contactsProjectHandle(event.target.value); }
            }}
            onKeyPress={(event) => {
              if (event.key === 'Enter') {
                event.preventDefault();
                const element = event.target as HTMLInputElement;
                const value = element.value;
                if (value !== preValue && value) {
                  contactsProjectHandle(value);
                }
              }
            }}
            name="search"
            InputProps={{
              endAdornment: (
                <IconButton>
                  <SearchOutlined />
                </IconButton>
              ),
            }}
          />
        </Grid>
      </Grid>

      {
        (() => {
          if (canEditing) {
            if (addedContact) {
              return (
                <Typography
                  component="p"
                  variant="body1"
                >
                </Typography>
              )
            }
            return (
              <Collapse in={add}>
                <Typography
                  component="p"
                  variant="body1"
                >
                  Create new contact
                </Typography>
                <Grid>
                  <>
                    <FormControl
                      component="form"
                      onSubmit={formik.handleSubmit}
                      className='form'
                    >
                      <Grid sm={12} sx={{
                        display: 'flex',
                        alignItems: 'center',
                        width: '100%'
                      }}>
                        <Autocomplete
                          sx={{
                            width: '440px !important',
                          }}
                          id="infoContacts"
                          freeSolo
                          className='autocomplete'
                          ref={nameRef}
                          open={openInfoContact}
                          options={options}
                          onOpen={() => {
                            setOpenInfoContact(true);
                          }}
                          onClose={() => {
                            setOpenInfoContact(false);
                          }}
                          disabled={disabledField}
                          renderOption={(props, option) => (
                            <li {...props}>
                              {`${option.full_name} - ${option.email}`}
                            </li>
                          )}
                          value={valueInfoUser}
                          onChange={(event: any, newValue: CompanyManager | null | undefined | string) => {
                            if (typeof newValue === 'string') {
                              formik.setFieldValue('name', newValue);
                              setValueInfoUser({
                                full_name: newValue,
                                email: '',
                              } as CompanyManager);
                            } else if (newValue && newValue.email) {
                              setValueInfoUser(newValue as CompanyManager);
                              formik.setFieldValue('email', newValue?.email);
                              formik.setFieldValue('name', newValue?.full_name);
                              formik.setFieldValue('phone', newValue?.phone);
                              setDisabledField(true);
                            } else if (newValue) {
                              setValueInfoUser(newValue as CompanyManager);
                              formik.setFieldValue('name', newValue?.first_name);
                            }
                          }}
                          filterOptions={(optionsFilter, params: any) => {
                            const filtered = optionsFilter as CompanyManager[];
                            const { inputValue } = params;
                            // Suggest the creation of a new value
                            const isExisting = optionsFilter.some((option) => inputValue === option.full_name);
                            if (inputValue !== '' && !isExisting) {
                              filtered.push({
                                first_name: inputValue,
                                full_name: `Add user "${inputValue}"`,
                                email: '',
                              } as CompanyManager);
                            }
                            return filtered;
                          }}
                          getOptionLabel={(option) => {
                            if (typeof option === 'string') {
                              return option;
                            }
                            if (option.full_name.includes('Add user')) {
                              return `${option.first_name}`
                            }
                            return `${option.full_name}`;
                          }}
                          loading={loadingSearch}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              required
                              className='textfield'
                              sx={{
                                color: 'blue',
                              }}
                              placeholder="Search a co-worker by name or add a new one"
                              onChange={(ev) => {
                                if (ev.target.value !== '' || ev.target.value !== null) {
                                  onChangeSearchUserHandle(ev.target.value);
                                }
                              }}
                              InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                  <>
                                    {loadingSearch ? <CircularProgress color="primary" size={20} /> : null}
                                    {params.InputProps.endAdornment}
                                  </>
                                ),
                              }}
                            />
                          )}
                        />
                        <TextField
                          required
                          id="email"
                          label="Email"
                          name="email"
                          className='textfield'
                          autoComplete="email"
                          disabled={disabledField}
                          value={formik.values.email}
                          onChange={formik.handleChange}
                          error={formik.touched.email && Boolean(formik.errors.email)}
                          helperText={formik.touched.email && formik.errors.email}
                        />
                        <TextField
                          required
                          id="phone"
                          label="Phone"
                          name="phone"
                          className='textfield'
                          autoComplete="phone"
                          disabled={disabledField}
                          value={formik.values.phone}
                          onChange={formik.handleChange}
                          error={formik.touched.phone && Boolean(formik.errors.phone)}
                          helperText={formik.touched.phone && formik.errors.phone}
                        />
                        <FormControl
                          className='form-jobtitle'
                        >
                          <JobTitle
                            clear={toCleanJobTitle}
                            value={formik.values.jobTitle}
                            formik={formik}
                            error={formik.touched.jobTitle && Boolean(formik.errors.jobTitle)}
                            helperText={formik.touched.jobTitle && formik.errors.jobTitle}
                          />
                        </FormControl>
                      </Grid>
                      <Grid sx={{
                        width: '100%',
                        paddingLeft: '18px'
                      }}>
                        <Button
                          type="submit"
                          variant="contained"
                          sx={{ my: 2, mr: 2, fontWeight: 500 }}
                        >
                          {loader ? <CircularProgress size={20} color="secondary" /> : 'Send'}
                        </Button>
                        <Button
                          color='inherit'
                          variant="contained"
                          sx={{ my: 2, mr: 2, fontWeight: 500 }}
                          onClick={() => {
                            formik.resetForm();
                            setToCleanJobTitle(true);
                            setDisabledField(false);
                          }}
                        >
                          Clear
                        </Button>
                        <Button
                          type="reset"
                          color="secondary"
                          variant="contained"
                          onClick={() => {
                            formik.resetForm();
                            setAdd(false);
                            setAddedContact(true);
                            setValueInfoUser(null);
                          }}
                          sx={{ my: 2, fontWeight: 500 }}
                        >
                          Cancel
                        </Button>
                      </Grid>
                    </FormControl>
                  </>
                </Grid>
              </Collapse>
            )
          }
          return null
        })()
      }
      {loadingContacts
        ? (
          <CircularLoading />
        )
        : (contacts
          ? (
            <ContactsTable
              contacts={contacts.userListFromProject as [UserNode]}
              deleteUsersProject={deleteUsers}
              openModal={openModal}
              handleCloseModal={handleCloseModal}
              handleOpenModal={handleOpenModal}
              canEditing={canEditing}
            />
          )
          : (
            <Typography
              variant="body1"
              component="p"
              sx={{
                fontWeight: 300,
              }}
            >
              No contacts
            </Typography>
          )
        )}
    </>
  );
}

export default ContactsPage;
